(function() {
  'use strict';

  angular
    .module('admin.channel_group_children', [
      'admin.channel_group.children.service'
    ])
    .controller('ChannelGroupChildrenAdminCtrl', ChannelGroupChildrenAdminCtrl);

  /** @ngInject */
  function ChannelGroupChildrenAdminCtrl($scope, $state, $stateParams, ChannelGroupService, ChannelGroupChildrenService, UploadService) {
    var vm = this;
    vm.parentId = $stateParams.parentId;
    vm.items = [];
    vm.group = {
      'img-t': ''
    };

    vm.loadT = false;
    vm.pathImgT = '';
    vm.pathImgH = '';
    vm.create = false;
    vm.model = {};
    vm.totalUsers = 0;
    vm.usersPerPage = 25;
    vm.oldPage = 0;
    vm.currentPage = 25;
    vm.first = true;
    vm.totalItems = 0;
    vm.pagination = {
      current: 1
    };

    vm.sortType = 'n-asc';
    vm.sortReverse = false;

    vm.sizes = [
      {
        id: 11,
        name: 'Size: 1x1'
      },
      {
        id: 21,
        name: 'Size: 2x1'
      },
      {
        id: 31,
        name: 'Size: 3x1'
      },
      {
        id: 22,
        name: 'Size: 2x2'
      }
    ];

    if (vm.parentId !== "") {
      ChannelGroupService.get(vm.parentId).then(function(result){
        vm.group = result.results;
      });

      load(1);
    }

    ChannelGroupChildrenService.listChannel().then(function(result){
      vm.channels = result.results;
    });

    function load(pageNumber){
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      }
      else {
        vm.first = false;
      }
      ChannelGroupChildrenService.list(vm.parentId, vm.oldPage, 25, vm.sortType).then(function(result){
        var channels = result.results;
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }
        for (var i = 0; i < channels.length; i++) {
          if (pageNumber === 1 && i === 0) {
            channels[i].firstRow = true;
          }

          if ((channels.length-1) === i && channels.length<vm.currentPage) {
            channels[i].lastRow = true;
          }
          channels[i].editing = false;
        }
        vm.items = channels;
        vm.disableTable = false;

        if (vm.items.length === 0 && vm.group.id !== undefined) {
          ChannelGroupService.unpublish(vm.group.id).then(function(){
          });
        }
      });
    }

    vm.pageChanged = function(newPage) {
      load(newPage);
    };

    vm.add = function(){
      vm.channelId = null;
      $('#myModal').modal('show');
    };

    vm.selectChannel = function(){
      if (vm.parentId !== "") {
        swal({
            title: "Are you sure ?",
            text: "You want to associate this channel from group",
            type: "warning",
            showCancelButton: true,
            closeOnConfirm: true,
            animation: "slide-from-top",
          }, function(isConfirm) {
            if (isConfirm) {
              $('#myModal').modal('hide');
              var model = {
                'id-ch': parseInt(vm.channelId),
                'id-cg': parseInt(vm.parentId),
                's-img': 11
              };
              vm.save(model);
            }
        });
      } else {
        swal('Need upload image first.', '', 'warning');
        return;
      }
    };

    vm.save = function(item){
      vm.create = false;
      if (item.id !== undefined && item.id !== '' && item.id !== 0) {
        ChannelGroupChildrenService.update(vm.parentId, item.id, item).then(function(){
          load(vm.pagination.current);
        });
      } else {
        delete item.id;
        delete item.editing;
        ChannelGroupChildrenService.save(vm.parentId, item).then(function(){
          load(vm.pagination.current);
        });
      }
    };

    vm.changeSize = function(item){
      ChannelGroupChildrenService.update(vm.parentId, item.id, {'s-img': item['s-img']}).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.delete = function(item){
      swal({
          title: "Are you sure ?",
          text: "You want delete this channel from group",
          type: "warning",
          showCancelButton: true,
          closeOnConfirm: true,
          animation: "slide-from-top",
        }, function(isConfirm) {
          if (isConfirm) {
            ChannelGroupChildrenService.remove(vm.parentId, item.id).then(function(){
              if (vm.items.length === 1 || vm.items.length === 25) {
                $state.reload();
              } else {
                load(vm.pagination.current);
              }
            });
          }
      });
    };

    vm.back = function(){
      $state.go('admin.channel_group');
    };

     vm.showDescription = function(item){
      $('#myModal').modal('show');
      $('#myModal').on('shown.bs.modal', function () {
        $('#description').text(item);
      });
    };

    vm.arrowUp = function(item){
      var copy = angular.copy(item);
      copy.n = copy.n -1;
      ChannelGroupChildrenService.update(vm.parentId, copy.id, {n: copy.n}).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.arrowDown = function(item){
      var copy = angular.copy(item);
      copy.n = copy.n +1;
      ChannelGroupChildrenService.update(vm.parentId, copy.id, {n: copy.n}).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.disableTable = false;
    vm.barConfig = {
      animation: 150,
      onEnd: function (/** ngSortEvent */evt){
        vm.disableTable = true;
        vm.orderList(evt);
      }
    };

    vm.orderList = function(evt){
      for (var i = 0; i < vm.items.length; i++){
        vm.items[i].o = parseInt(evt.newIndex) + 1;
        if(vm.items[i].id === evt.model.id){
           vm.update(evt.model);
        }
      }
    };

    vm.update = function(model){
      ChannelGroupChildrenService.update(vm.parentId, model.id, {n: model.o}).then(function(){
        load(vm.pagination.current);
      });
    };

    vm.uploadT = function(){
      vm.loadT = true;
      UploadService.save('channel_groups', vm.pathImgT, 'img-t', 0).then(function(fileName){
        vm.loadT = false;
        vm.group['img-t'] = fileName;
        if (vm.group.id !== undefined && vm.group.id !== '' && vm.group.id !== 0) {
          ChannelGroupService.update(vm.group.id, {'img-t': vm.group['img-t']}).then(function(result){
            vm.group.id = result.results.id;
            vm.parentId = vm.group.id;
          });
        } else {
          ChannelGroupService.save({'img-t': vm.group['img-t']}).then(function(result){
            vm.group.id = result.results.id;
            vm.parentId = vm.group.id;
          });
        }
      });
    };
  }

})();
